import axios from "axios";

//const PHP_SCORE_URL = 'http://localhost/games/Truth-And-Trick-admin/api/ScoreApi.php';
 const PHP_SCORE_URL = process.env.REACT_APP_PHP_SCORE_ADD_URL;

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export async function alreadyPlayed(data) {
  if (!PHP_SCORE_URL) return null;
  const headers = { "Content-Type": "application/json" };
  
  const method = "POST";
  if (["POST", "PUT"].includes(method)) {
    headers["Idempotency-Key"] = uuidv4();
    console.log("Added Idempotency-Key:", headers["Idempotency-Key"]);
  }
  
  const res = await axios.post(
    PHP_SCORE_URL,
    {
      action: "check",
      userId: data.userId,
      sessionId: data.sessionId,
      organizationId: data.organizationId,
    },
    { headers }
  );
  return res.data;
}

export async function insertScore(data) {
  if (!PHP_SCORE_URL) return { status: "error", message: "PHP_SCORE_ADD_URL not configured" };
  const res = await axios.post(
    PHP_SCORE_URL,
    {
      action: "insert",
      userId: data.userId,
      sessionId: data.sessionId,
      organizationId: data.organizationId,
      roles: data.roles || "ORG_USER",
      name: data.name,
      email: data.email || "",
      points: data.points != null ? data.points : 0,
      time: data.time || "00:00",
    },
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
}

export async function updateScore(data) {
  if (!PHP_SCORE_URL) return { status: "error", message: "PHP_SCORE_ADD_URL not configured" };
  const res = await axios.post(
    PHP_SCORE_URL,
    {
      action: "update",
      userId: data.userId,
      sessionId: data.sessionId,
      organizationId: data.organizationId,
      points: data.points != null ? data.points : 0,
      time: data.time || "00:00",
      statement: data.statement || "",
    },
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
}

export async function updateReport(data) {
  if (!PHP_SCORE_URL) return { status: "error", message: "PHP_SCORE_ADD_URL not configured" };
  const res = await axios.post(
    PHP_SCORE_URL,
    {
      action: "updatereport",
      userId: data.userId,
      sessionId: data.sessionId,
      organizationId: data.organizationId,
      reportId: data.reportId,
    },
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
}
